import React, { useEffect, useState } from 'react'
import { api_url, titleDescription } from '../../config/Config';
import { Table } from 'react-bootstrap';
import _fetch from '../../config/api';
import dateformat from "dateformat";
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate";


const DirectsList = (props: any) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [history, setHistory] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setpage] = useState(1);
    const [limit, setLimit] = useState(100);
    const [keyCount, setKeyCount] = useState(0);

    useEffect(() => {
        getDirectsHistory();
    }, [page, limit]);

    const getDirectsHistory = async () => {
        setLoading(true);
        let res = await _fetch(`${api_url}report/directs-summary?limit=${limit}&page=${page}`, "GET", {});
        if (res?.status === "success") {
            setLoading(false);
            setHistory(res?.data);
            setTotalRecords(res?.total);
        }
        if (page > 1) {
            setKeyCount(0);
            var count = page - 1;
            setKeyCount(count * limit);
        }
    }

    const handlePageClick = async (event: any) => {
        const newOffset = (event.selected + 1);
        setpage(newOffset);
    };

    return (
        <main>
            <div className="ticket_view">
                <div className="coustom_contanier">
                    <div className="ticket_inner loader_main">
                        {loading &&
                            <div className="spinner_bg">
                                <div className="color_ring">  <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                                />
                                </div>
                            </div>
                        }
                        <h4>{t("Directs List")}</h4>
                        <div className="table_section ">
                            <div className="scrolling_table">
                                <div className="scroll_under">
                                    <Table className="support_table">
                                        <thead>
                                            <tr className="table_heading_row">
                                                <th className="table_heading">#</th>
                                                <th className="table_heading">{t("Username")}</th>
                                                <th className="table_heading">{t("Name")}</th>
                                                <th className="table_heading">{t("Email")}</th>
                                                <th className="table_heading">{t("Status")}</th>
                                                <th className="table_heading">{t("Self Package")}</th>
                                                <th className="table_heading">{t("Team Business")}</th>
                                                <th className="table_heading">{t("Date")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {history?.map((item: any, index: any) => {
                                                console.log('item', item);
                                                return (
                                                    <>
                                                        <tr className="table_data_row">
                                                            <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                                                            <td className="table_data"><div className="pic_text">{item?.username}</div> </td>
                                                            <td className="table_data">{item?.user_info?.name}</td>
                                                            <td className="table_data">{item?.email}</td>
                                                            <td className={`table_data ${item?.active_status == true ? 'text-success' : 'text-danger'}`}>{item?.active_status == true ? 'Active' : 'InActive'}</td>
                                                            <td className="table_data">{item?.income_info?.trade_fund && item?.income_info?.compound_trade_fund ? item?.income_info?.trade_fund + item?.income_info?.compound_trade_fund : item?.income_info?.compound_trade_fund || item?.income_info?.compound_trade_fund}</td>
                                                            <td className="table_data">{item?.teamBusiness}</td>
                                                            <td className="table_data"> {dateformat(item?.created_at, "dd-mm-yyyy hh:MM:ss TT")} </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                    {totalRecords > 100 && <ReactPaginate className="pagination__2 " activeClassName="active"
                                        breakLabel="..."
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={1}
                                        pageCount={totalRecords / 100}
                                        previousLabel="<"
                                    />}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default DirectsList